import  {__extends} from './eXcell';
import  eXcell_co from './eXcell_co';
import {dhx4} from '../../global/dhx4OrDhx';


var eXcell_cotxt = (function (_super) {
    __extends(eXcell_cotxt, _super);
    function eXcell_cotxt(a) {
        _super.call(this, a);
    }
    eXcell_cotxt.prototype.getText = function () {
        return dhx4.isIE ? this.cell.innerText : this.cell.textContent;
    };
    eXcell_cotxt.prototype.setValue = function (e) {
        if (typeof e == "object") {
            var c = dhx4.ajax.xpath("./option", e);
            if (c.length) {
                this.cell._combo = new dhtmlXGridComboObject();
            }
            for (var a = 0; a < c.length; a++) {
                this.cell._combo.put(c[a].getAttribute("value"), c[a].firstChild ? c[a].firstChild.data : "");
            }
            e = e.firstChild.data;
        }
        if ((e || "").toString()._dhx_trim() == "") {
            e = null;
        }
        if (e !== null) {
            this.setCTxtValue((this.cell._combo || this.grid.getCombo(this.cell._cellIndex)).get(e) ||
                e, e);
        }
        else {
            this.setCTxtValue(" ", e);
        }
        this.cell.combo_value = e;
    };
    return eXcell_cotxt;
})(eXcell_co);
window.eXcell_cotxt = eXcell_cotxt;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_cotxt.js